// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3uU4u","consentsList":"PatientConsents_consentsList__3dzTV","consentsListEmpty":"PatientConsents_consentsListEmpty__3rNFi"};